export function getMonthlyTotals(invoiceData, expenseData, itemData, chartGrouping) {
  const monthlyTotals = [];
  const allData = [...invoiceData, ...expenseData, ...itemData];

  const dataByTimePeriod = allData && allData.reduce((acc, entry) => {
    let timePeriodKey;

    switch (chartGrouping) {
      case 'byDay':
        timePeriodKey = new Date(entry.issuedate || entry.expensedate || entry.purchase_date).toLocaleString('en-US', { day: '2-digit', month: '2-digit', year: '2-digit' });
        break;
      case 'byMonth':
        timePeriodKey = new Date(entry.issuedate || entry.expensedate || entry.purchase_date).toLocaleString('en-US', { month: 'short', year: 'numeric' });
        break;
      case 'byYear':
        timePeriodKey = new Date(entry.issuedate || entry.expensedate || entry.purchase_date).toLocaleString('en-US', { year: 'numeric' });
        break;
      default:
        break;
    }

    if (!acc[timePeriodKey]) {
      acc[timePeriodKey] = { totalProfit: 0, totalSales: 0, totalExpenses: 0, totalPurchases: 0 };
    }

    if (entry.total) {
      acc[timePeriodKey].totalSales += parseFloat(entry.total);
    }
    if (entry.incomeamount) {
      acc[timePeriodKey].totalPurchases += parseFloat(entry.incomeamount);
    }

    if (entry.amount || entry.incomeamount) {
      if (entry.amount && entry.incomeamount) {
        acc[timePeriodKey].totalExpenses += (parseFloat(entry.amount) + parseFloat(entry.incomeamount));
      } else if (entry.amount) {
        acc[timePeriodKey].totalExpenses += parseFloat(entry.amount);
      } else if (entry.incomeamount) {
        acc[timePeriodKey].totalExpenses += parseFloat(entry.incomeamount);
      }
    }

    acc[timePeriodKey].totalProfit = acc[timePeriodKey].totalSales - acc[timePeriodKey].totalExpenses;

    return acc;
  }, {});

  for (const timePeriodKey in dataByTimePeriod) {
    const formattedDate = new Date(timePeriodKey).toLocaleString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });

    monthlyTotals.push({
      timePeriod: formattedDate,
      totalProfit: dataByTimePeriod[timePeriodKey].totalProfit,
      totalSales: dataByTimePeriod[timePeriodKey].totalSales,
      totalExpenses: dataByTimePeriod[timePeriodKey].totalExpenses,
      totalPurchases: dataByTimePeriod[timePeriodKey].totalPurchases,
    });
  }

  monthlyTotals.sort((a, b) => new Date(a.timePeriod) - new Date(b.timePeriod));

  return monthlyTotals;
};